import React from 'react';
import CVEChart from './CVEChart';
import ComparisonBarChart from './ComparisonBarChart';
import SBOMComparison from './SBOMComparison';

const ImageCard = ({ title, data, isKoala = false }) => {
  const totalCVEs = data.cves.length;

  return (
    <div className={`image-card ${isKoala ? 'koala-card' : 'dockerhub-card'}`}>
      <div className="card-header">
        <h3>{title}</h3>
        <div className="image-name">{data.image}</div>
      </div>
      
      <div className="metric-section">
        <div className="metrics-row">
          <div className="metric-item">
            <h4>Image Size</h4>
            <div className="size-metric">{data.size}</div>
          </div>
          <div className="metric-item">
            <h4>CVE Count</h4>
            <div className="cve-count-metric">{totalCVEs} vulnerabilities</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ComparisonView = ({ imageData }) => {
  if (!imageData) {
    return (
      <div className="comparison-placeholder">
        <p>Select an image above to see the comparison</p>
      </div>
    );
  }

  return (
    <div className="comparison-container">
      <div className="comparison-header">
        <h2>Container Image Security Comparison: {imageData.name}</h2>
        <p className="subtitle">Koala Hardened vs DockerHub Alternative</p>
      </div>

      <div className="comparison-grid">
        <ImageCard 
          title="Koala Hardened"
          data={imageData.koala}
          isKoala={true}
        />
        <ImageCard 
          title="DockerHub Alternative"
          data={imageData.dockerhub}
          isKoala={false}
        />
      </div>

      <div className="summary-section">
        <h3>Security Improvement Summary</h3>
        <div className="improvements">
          <div className="improvement-item">
            <span className={`improvement-percentage ${Math.round(((imageData.dockerhub.size_in_mb - imageData.koala.size_in_mb) / imageData.dockerhub.size_in_mb) * 100) === 100 ? 'hundred-percent' : ''}`}>
              {Math.round(((imageData.dockerhub.size_in_mb - imageData.koala.size_in_mb) / imageData.dockerhub.size_in_mb) * 100)}%
            </span>
            <span className="improvement-text">
              smaller image
            </span>
          </div>
          <div className="improvement-item">
            <span className={`improvement-percentage ${Math.round(((imageData.dockerhub.sbom.totalPackages - imageData.koala.sbom.totalPackages) / imageData.dockerhub.sbom.totalPackages) * 100) === 100 ? 'hundred-percent' : ''}`}>
              {Math.round(((imageData.dockerhub.sbom.totalPackages - imageData.koala.sbom.totalPackages) / imageData.dockerhub.sbom.totalPackages) * 100)}%
            </span>
            <span className="improvement-text">
              fewer packages
            </span>
          </div>
          <div className="improvement-item">
            <span className={`improvement-percentage ${(imageData.dockerhub.cves.length > 0 ? Math.round(((imageData.dockerhub.cves.length - imageData.koala.cves.length) / imageData.dockerhub.cves.length) * 100) : 100) === 100 ? 'hundred-percent' : ''}`}>
              {imageData.dockerhub.cves.length > 0 
                ? Math.round(((imageData.dockerhub.cves.length - imageData.koala.cves.length) / imageData.dockerhub.cves.length) * 100) + '%'
                : '100%'}
            </span>
            <span className="improvement-text">
              fewer vulnerabilities
            </span>
          </div>
          {imageData.cve_accumulation_since && (
            <div className="improvement-item">
              <span className={`improvement-percentage ${(() => {
                const accumulationDate = new Date(imageData.cve_accumulation_since);
                const koalaCVEsSince = imageData.koala.cves.filter(cve => new Date(cve.publishedDate) >= accumulationDate).length;
                const dockerhubCVEsSince = imageData.dockerhub.cves.filter(cve => new Date(cve.publishedDate) >= accumulationDate).length;
                const percentage = dockerhubCVEsSince === 0 ? 100 : Math.round(((dockerhubCVEsSince - koalaCVEsSince) / dockerhubCVEsSince) * 100);
                return percentage === 100 ? 'hundred-percent' : '';
              })()}`}>
                {(() => {
                  const accumulationDate = new Date(imageData.cve_accumulation_since);
                  const koalaCVEsSince = imageData.koala.cves.filter(cve => new Date(cve.publishedDate) >= accumulationDate).length;
                  const dockerhubCVEsSince = imageData.dockerhub.cves.filter(cve => new Date(cve.publishedDate) >= accumulationDate).length;
                  
                  if (dockerhubCVEsSince === 0) return '100%';
                  return Math.round(((dockerhubCVEsSince - koalaCVEsSince) / dockerhubCVEsSince) * 100) + '%';
                })()}
              </span>
              <span className="improvement-text">
                fewer CVEs since {new Date(imageData.cve_accumulation_since).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
              </span>
            </div>
          )}
        </div>
      </div>

      <ComparisonBarChart imageData={imageData} />

      <CVEChart imageData={imageData} />

      <SBOMComparison imageData={imageData} />
    </div>
  );
};

export default ComparisonView;